import { fragSamplerMask } from '../shaders/frag-sampler-mask.shader';
import { vertSampler } from '../shaders/vert-sampler.shader';

import { BaseUniformData } from './pipeline-base';
import { TexturePipelineBase } from './pipeline-texBase';
import { PipelineGlUtils } from './utils/pipeline-utils-gl';

export class MaskedTexturePipeline extends TexturePipelineBase {
  public invertMaskEffect: boolean;

  public constructor(invertMaskEffect: boolean) {
    super(vertSampler, fragSamplerMask);

    this.invertMaskEffect = invertMaskEffect;
  }

  public CreateTextures(imgDataList: ImageData[]): WebGLTexture[] {
    if (imgDataList.length !== 2) {
      throw new Error(`CreateTextures called without exactly 2 textures.`);
    }

    return super.CreateTextures(imgDataList);
  }

  protected InitShaderProps(shaderProgram: WebGLProgram) {
    super.InitShaderProps(shaderProgram);

    this.shaderProgramProps.u_samplerToMask = PipelineGlUtils.GetUniformLocation(this.gl, shaderProgram, 'uSamplers[0]');
    this.shaderProgramProps.u_samplerAsMask = PipelineGlUtils.GetUniformLocation(this.gl, shaderProgram, 'uSamplers[1]');
    this.shaderProgramProps.u_invertMaskAlpha = PipelineGlUtils.GetUniformLocation(this.gl, shaderProgram, 'uInvertMaskAlpha');
  }

  protected SetUniforms(data: BaseUniformData) {
    super.SetUniforms(data);

    // * TextureToMask
    PipelineGlUtils.SetTextureUniform(this.gl, this.gl.TEXTURE0, this.glTextures[0], this.shaderProgramProps.u_samplerToMask, 0);
    // * TextureAsMask
    PipelineGlUtils.SetTextureUniform(this.gl, this.gl.TEXTURE1, this.glTextures[1], this.shaderProgramProps.u_samplerAsMask, 1);

    // ? Will number conversion turn the boolean into a 0 or 1 properly, for it to be set back to a boolean in the shader?
    this.gl.uniform1i(this.shaderProgramProps.u_invertMaskAlpha, Number(this.invertMaskEffect));
  }
}
